module.exports = __webpack_public_path__ + "static/media/paigejarrett.8685bf6c.png";